var App = (function () {
  'use strict';

  App.deal = function( ){
    var iconEditPaymentSelector = '.js-payment__icon-edit';
    var tableSelector = '.js-deal-payments';
    var formsSelectors = ['#mod-delete', '#form-add-refund', '#form-edit-refund', '#form-edit-payment'];

    var $table = $(tableSelector);
    if(!$table.length) {
      return;
    }

    var table = $table.DataTable({
      dom:  "<'row be-datatable-body'<'col-sm-12'tr>>",
      order: [],
      paging: false
    });

    $(tableSelector + ' tbody').on('click', iconEditPaymentSelector, function () {
      var tr = $(this).closest('tr');
      var row = table.row(tr);

      var id = $(this).attr('data-id');
      var amount = $(this).attr('data-amount');
      var datetime = getCellDataByName(row, 'datetime');
      var comment = getCellDataByName(row, 'comment');

      var formId = $(this).attr('data-target').substr(1);
      var form = document.getElementById(formId);
      var formFields = form.elements;

      formFields['id'].value = id;
      formFields['datetime'].value = datetime;
      formFields['amount'].value = amount;
      if(typeof formFields['comment'] !== 'undefined') {
        formFields['comment'].value = comment;
      }
    });

    initPageReload(table, formsSelectors);

    function getCellDataByName(row, columnName) {
      var idx = table.column(columnName + ':name').index();

      return row.data()[idx];
    }

    function initPageReload(table, formsSelectors) {
      formsSelectors.forEach(function(formSelector) {
        var $form = $(formSelector);
        $form.bind('success', function(){
          document.location.reload();
        });
      });
    }

  };

  return App;
})(App || {});
